module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modifier-box flex",
    attrs: {
      "data-column": _vm.column
    }
  }, [_c('div', {
    staticClass: "mainLabel"
  }, [_vm._v("\n    " + _vm._s(_vm.mainLabel) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex modifier-container"
  }, [_c('div', {
    staticClass: "modifier-top"
  }, [_c('div', {
    staticClass: "left-right-text"
  }, [_c('span', {
    staticClass: "left-text"
  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('span', {
    staticClass: "right-text"
  }, [_vm._v(_vm._s(_vm.rightText))])])]), _vm._v(" "), _c('div', {
    staticClass: "modifier-bottom"
  }, [_c('div', {
    staticClass: "sliders"
  }, [(_vm.sliders.sliderLeft.width) ? _c('vue-slider', {
    attrs: {
      "width": _vm.sliders.sliderLeft.width,
      "adsorb": true,
      "interval": parseFloat(_vm.step),
      "data": _vm.sliders.sliderLeft.data,
      "marks": true,
      "disabled": true
    },
    scopedSlots: _vm._u([{
      key: "dot",
      fn: function() {
        return [_c('img', {
          staticClass: "custom-dot",
          attrs: {
            "src": "",
            "alt": ""
          }
        })]
      },
      proxy: true
    }], null, false, 3359372436)
  }) : _vm._e(), _vm._v(" "), (_vm.sliders.sliderMiddle.width) ? _c('vue-slider', {
    ref: "slider",
    attrs: {
      "width": _vm.sliders.sliderMiddle.width,
      "adsorb": true,
      "interval": 1,
      "included": true,
      "marks": _vm.sliders.sliderMiddle.marks,
      "tooltip": 'always',
      "tooltip-formatter": _vm.tooltipFormatter,
      "tooltip-placement": 'bottom'
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "dot",
      fn: function() {
        return [_c('img', {
          staticClass: "custom-dot",
          attrs: {
            "src": _vm.imgUrl,
            "width": "18",
            "height": "18",
            "value": "0",
            "alt": ""
          }
        })]
      },
      proxy: true
    }], null, false, 2175556904),
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sliders.sliderRight.width) ? _c('vue-slider', {
    attrs: {
      "width": _vm.sliders.sliderRight.width,
      "adsorb": true,
      "interval": parseFloat(_vm.step),
      "data": _vm.sliders.sliderRight.data,
      "marks": true,
      "disabled": true
    },
    scopedSlots: _vm._u([{
      key: "dot",
      fn: function() {
        return [_c('img', {
          staticClass: "custom-dot",
          attrs: {
            "src": "",
            "alt": ""
          }
        })]
      },
      proxy: true
    }], null, false, 3359372436)
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ee418ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modifier.vue
// module id = 501
// module chunks = 1